import { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { MapBox } from './MapBox';
import { LocationData, LocationSelectionProps } from '../types';
import { DialogBox } from './DialogBox';

const LocationSelection = ({
  open,
  onClose,
  onLocationSelect,
  initialLocation,
  title = 'Select Location',
  subTitle = 'Search for a location or click on the map to select',
  confirmButtonText = 'Confirm Location',
  cancelButtonText = 'Cancel',
}: LocationSelectionProps) => {

  const [selectedLocation, setSelectedLocation] = useState<LocationData | null | undefined | any>(initialLocation ? { coordinates: initialLocation } : null);

  const handleLocationChange = useCallback((coordinates: [number, number], address: string, postcode: string, what3_words: string) => {
    setSelectedLocation({ coordinates, address, postcode, what3_words });
  }, []);

  const handleConfirm = useCallback(() => {
    onLocationSelect?.(selectedLocation);
    onClose();
  }, [selectedLocation, onLocationSelect, onClose]);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const actions = [
    {
      label: cancelButtonText,
      icon: 'reset' as const,
      variant: 'outlined' as const,
      handleClick: handleCancel,
    },
    {
      label: confirmButtonText,
      icon: 'success' as const,
      variant: 'contained' as const,
      handleClick: handleConfirm,
      disabled: !selectedLocation,
    },
  ];

  return (
    <DialogBox
      title={title}
      subTitle={subTitle}
      showModal={open}
      onModalClose={handleCancel}
      actions={actions}
      maxWidth="lg"
      fullWidth
    >
      <Box sx={{ height: '500px', width: '100%' }}>
        <MapBox
          location={selectedLocation?.coordinates || initialLocation}
          enableGeocoder
          onLocationChange={handleLocationChange}
        />
      </Box>
    </DialogBox>
  );
};

export default LocationSelection;
